import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Header from '../../components/Header/Header'
import { getUser, loadGoogleScript, doSocialLogin } from '../../actions/login'
import { API_FAIL } from '../../actions/dashboard'
import CommonLoader from '../../components/CommonLoader/CommonLoader'

if (process.env.WEBPACK) {
  require('./Login.css')
}

const mapStateToProps = state => ({
  isLoggedIn: state.isLoggedIn,
  userInfo: state.userInfo
})

const mapDispatchToProps = dispatch => ({
  getUser: bindActionCreators(getUser, dispatch),
  doSocialLogin: bindActionCreators(doSocialLogin, dispatch),
  dispatch
})

const clientId =
  '513260976413-6c6mcp6pjj5la5t7tl17k3vn2na6t14s.apps.googleusercontent.com'
class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoader: false,
      googleAccounts: null
    }
    this.toggleLoader = this.toggleLoader.bind(this)
    this.handleKeyPressEnter = this.handleKeyPressEnter.bind(this)
  }

  gotoDashboard = () => {
    const { redirectTo } = this.props.location.query
    this.props.router.replace(redirectTo || '/broker-dashboard')
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn) {
      this.gotoDashboard()
    }
  }

  componentDidMount() {
    if (!this.props.userInfo) {
      this.props.getUser()
    } else {
      this.gotoDashboard()
    }
    const { dispatch } = this.props
    document.addEventListener('keydown', this.handleKeyPressEnter)

    loadGoogleScript()
      .then(response => {
        this.setState({ googleAccounts: response })
      })
      .catch(error => {
        const { message } = error || {}
        dispatch({
          type: API_FAIL,
          errMsg: message
        })
      })
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPressEnter)
  }

  toggleLoader = showLoader => {
    this.setState({
      showLoader
    })
  }

  onSignInClick = () => {
    const { doSocialLogin, dispatch } = this.props
    const { googleAccounts } = this.state

    this.toggleLoader(true)
    if (!googleAccounts) return

    try {
      const tokenClient = googleAccounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: 'profile email',
        callback: tokenResponse => {
          if (tokenResponse && tokenResponse.access_token) {
            doSocialLogin(tokenResponse.access_token, this.toggleLoader)
          } else {
            dispatch({
              type: API_FAIL,
              errMsg: 'Failed to obtain access token'
            })
            this.toggleLoader(false)
          }
        }
      })

      tokenClient.requestAccessToken()
    } catch (error) {
      const { message } = error || {}
      dispatch({
        type: API_FAIL,
        errMsg: message
      })
      this.toggleLoader(false)
    }
  }

  handleKeyPressEnter(event) {
    if (event.key === 'Enter') {
      this.onSignInClick()
    }
  }

  render() {
    const { showLoader } = this.state
    return (
      <div>
        <Header
          {...this.props}
          title='Login page for Unified RCM'
          description='Login Description'
          hideLogin
        />
        <div className='login'>
          <div className='rcm-text'>Login To RCM</div>
          <div className='login-btn' onClick={this.onSignInClick}>
            <div className='logo' />
            <div className='btn-text'>Sign in with Google</div>
          </div>
          {showLoader && (
            <CommonLoader
              size={52}
              propStyle={{ position: 'absolute', left: '59%', top: '268px' }}
            />
          )}
        </div>
      </div>
    )
  }
}

Login.propTypes = {
  isLoggedIn: PropTypes.bool,
  loadGoogleScript: PropTypes.func,
  handleSignIn: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



/** WEBPACK FOOTER **
 ** ./src/containers/Login/Login.js
 **/